import type { AxiosError } from 'axios'

class ApiError extends Error {
    constructor(
        public previousError: AxiosError,
        public status?: number,
        public identifier?: string,
        public missingNetworkConnection?: boolean
    ) {
        super(previousError.message)

        this.name = 'ApiError'
    }
}

export default ApiError

export class ApiNotReadyError extends Error {
    constructor() {
        super('API is not ready.')

        this.name = 'ApiNotReadyError'
    }
}
